// extracted by mini-css-extract-plugin
module.exports = {"wrap":"yj","heading":"zj","items":"Aj","featureCss":"Bj","disabled":"Cj","imgCss":"Dj"};